import { get } from 'lodash';
import {
  FETCH_REWARD_PROGRAM_RULES,
  FETCH_REWARD_POINTS_TRANSACTIONS,
  FETCH_REWARD_POINTS,
  UPDATE_GUEST_COUPON_FILTER,
  UPDATE_REWARD_POINT_TRANSACTION_FILTER,
  DISPATCH_CALLBACK_URL,
  SIGNUP_DETAILS,
  FETCH_VIP_PASSES,
  FETCH_VIP_PASS_DATA,
  FETCH_VIP_PASS_COUPONS,
  CLEAR_VIP_PASS_DATA,
  FETCH_PASS_MEMBERSHIP_BY_ID,
  FETCH_PASS_MEMBERSHIPS,
  CLEAR_PASS_MEMBERSHIPS,
  DISPATCH_SUBSCRIBED_MEMBERSHIP,
  FETCH_ALL_SUB_BRANDS,
  UPDATE_PAY_EARN_DATA,
  UPDATE_BOOK_TABLE_DATA,
  FETCH_GUEST_LAST_ORDER,
  FETCH_REFERRAL_CODE,
  FETCH_REFERRAL_DEALS,
  FETCH_NEAYBY_HOOD,
  PLACE_BOOKING,
  FETCH_HOOD_ITEM_SLOTS,
  FETCH_BOOKING_DETAILS,
  FETCH_BOOKING_HISTORY,
  FETCH_USER_CONSENTS,
  UPDATE_USER_CONSENTS,
  FETCH_EXPERT_BOOKINGS,
} from './actionType';
import { BEGIN_AJAX_CALL, END_AJAX_CALL } from '../actionType';
import { apiErrorResponseAction } from '../app.action';

import {
  fetchRewardProgramRulesApi,
  fetchRewardPointsTransactionsApi,
  fetchRewardPointsApi,
  initiateDeleteAccountApi,
  initiateDeleteBrandGuestAccountApi,
  fetchVIPPassesApi,
  fetchVIPPassByIdApi,
  fetchVIPPassCouponsByIdApi,
  fetchPassMembershipByIdApi,
  subscribePassMembershipApi,
  fetchPassMembershipsApi,
  fetchAllSubBrandsApi,
  updatePaymentCartApi,
  paymentOrderPayApi,
  paymentOrderDetailsApi,
  validateReferralCodeApi,
  fetchReferralCodeApi,
  generateReferralCodeApi,
  fetchReferralDealsApi,
  fetchUserConsentsApi,
  updateUserConsentsApi,
  fetchExpertBookingsApi,
  serviceOTPSessionApi,
  fetchBookingHistoryApi,
  fetchBookingDetailsByIdApi,
  fetchBookingFeedbackOptionsApi,
  fetchBookingFeedbackStatusApi,
  fetchExpertFeedbackSummaryApi,
  createBookingFeedbackApi,
} from '../../api/api';

export const beginAjaxCallAction = () => async (dispatch) => {
  dispatch({
    type: BEGIN_AJAX_CALL,
    showSpinner: true,
  });
};

export const endAjaxCallAction = () => async (dispatch) => {
  dispatch({
    type: END_AJAX_CALL,
    showSpinner: false,
  });
};

export const fetchRewardProgramRulesAction =
  ({ brandId }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const rewardProgramResponse = await fetchRewardProgramRulesApi({ brandId })
        .then((response) => {
          dispatch({
            type: FETCH_REWARD_PROGRAM_RULES,
            rewardRules: get(response, 'data', {}),
          });
          return response;
        })
        .catch((error) => {
          console.log(error);
        });
      return rewardProgramResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const fetchRewardPointsTransactionAction =
  (requestBody, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const rewardPointsTransactionResponse = await fetchRewardPointsTransactionsApi(requestBody)
        .then((response) => {
          dispatch({
            type: FETCH_REWARD_POINTS_TRANSACTIONS,
            rewardPointTransactions: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return rewardPointsTransactionResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const fetchRewardPointsAction =
  ({ url }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const rewardPointsResponse = await fetchRewardPointsApi({ url })
        .then((response) => {
          dispatch({
            type: FETCH_REWARD_POINTS,
            rewardPoints: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return rewardPointsResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const initiateDeleteAccountAction =
  (requestBody, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const deleteAccountAPIResponse = await initiateDeleteAccountApi(requestBody)
        .then((response) => response)
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return deleteAccountAPIResponse;
    } catch (err) {
      console.error(err);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const initiateDeleteBrandGuestAccountAction =
  (requestBody, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const deleteRewardsAccountResponse = await initiateDeleteBrandGuestAccountApi(requestBody)
        .then((response) => response)
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response.data', {});
        });
      return deleteRewardsAccountResponse;
    } catch (err) {
      console.log(err);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const updateGuestCouponFilterAction = (requestBody) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_GUEST_COUPON_FILTER,
      filter: get(requestBody, 'filter', {}),
    });
  } catch (error) {
    console.log(error);
  }
};

export const updateRewardPointTransactionFilterAction = (requestBody) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_REWARD_POINT_TRANSACTION_FILTER,
      filter: get(requestBody, 'filter', {}),
    });
  } catch (error) {
    console.log(error);
  }
};

export const dispatchCallbackUrlAction =
  ({ callbackUrl }) =>
  async (dispatch) => {
    dispatch({
      type: DISPATCH_CALLBACK_URL,
      callbackUrl,
    });
  };

export const updateSignupDetailsAction = (signupDetails) => async (dispatch) => {
  try {
    dispatch({ type: SIGNUP_DETAILS, signupDetails });
  } catch (error) {
    console.log(error);
  }
};

export const fetchVIPPassesAction =
  ({ url }) =>
  async (dispatch) => {
    try {
      const vipPassesResponse = await fetchVIPPassesApi({ url })
        .then((response) => {
          const vipPasses = get(response, 'data', {});
          dispatch({
            type: FETCH_VIP_PASSES,
            vipPasses,
          });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return vipPassesResponse;
    } catch (err) {
      console.error(err);
    }
  };

export const fetchVIPPassByIdAction =
  ({ passCode, brandGuestId }) =>
  async (dispatch) => {
    try {
      const vipPassDetailResponse = await fetchVIPPassByIdApi({ passCode, brandGuestId })
        .then((response) => {
          const vipPassDetail = get(response, 'data', {});
          dispatch({
            type: FETCH_VIP_PASS_DATA,
            vipPassDetail,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return vipPassDetailResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const fetchVIPPassCouponsByIdAction =
  ({ url }) =>
  async (dispatch) => {
    try {
      const vipPassCouponsResponse = await fetchVIPPassCouponsByIdApi({ url })
        .then((response) => {
          const vipPassCoupons = get(response, 'data', {});
          dispatch({
            type: FETCH_VIP_PASS_COUPONS,
            vipPassCoupons,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return vipPassCouponsResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const clearVIPPassDataAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_VIP_PASS_DATA,
  });
};

export const fetchPassMembershipsAction =
  ({ url }) =>
  async (dispatch) => {
    try {
      const passMembershipsResponse = await fetchPassMembershipsApi({ url })
        .then((response) => {
          const passMemberships = get(response, 'data', {});
          dispatch({
            type: FETCH_PASS_MEMBERSHIPS,
            passMemberships,
          });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return passMembershipsResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const clearPassMembershipsAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_PASS_MEMBERSHIPS,
  });
};

export const fetchPassMembershipByIdAction =
  ({ membershipId, depth }) =>
  async (dispatch) => {
    try {
      const passMembershipResponse = await fetchPassMembershipByIdApi({ membershipId, depth })
        .then((response) => {
          const passMembership = get(response, 'data', {});
          dispatch({
            type: FETCH_PASS_MEMBERSHIP_BY_ID,
            passMembership,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return passMembershipResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const subscribePassMembershipAction =
  ({ subscribePassMembershipReqBody }) =>
  async (dispatch) => {
    try {
      const subscribedPassMembershipResponse = await subscribePassMembershipApi({
        subscribePassMembershipReqBody,
      })
        .then((response) => {
          const subscribedMembership = get(response, 'data', {});
          dispatch({
            type: DISPATCH_SUBSCRIBED_MEMBERSHIP,
            subscribedMembership,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return subscribedPassMembershipResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const fetchAllSubBrandAction = (payload) => async (dispatch) => {
  try {
    const subBrandsResponse = await fetchAllSubBrandsApi(payload)
      .then((response) => {
        dispatch({
          type: FETCH_ALL_SUB_BRANDS,
          subBrands: get(response, 'data', {}),
        });
        return response;
      })
      .catch((errorResponse) => {
        return errorResponse;
      });
    return subBrandsResponse;
  } catch (error) {
    console.log(error);
  }
};

export const updatePayEarnDataAction = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_PAY_EARN_DATA,
      payEarn: { ...payload },
    });
  } catch (error) {
    console.log(error);
  }
};

export const paymentOrderDetailsAction =
  (payload, withLoader = true) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const paymentOrderPayResponse = await paymentOrderDetailsApi(payload)
        .then((response) => {
          dispatch({
            type: UPDATE_PAY_EARN_DATA,
            order: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return errorResponse;
        });

      return paymentOrderPayResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const validateReferralCodeAction =
  ({ validateReferralCodeReqBody }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const response = await validateReferralCodeApi({ validateReferralCodeReqBody })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const fetchReferralCodeAction =
  ({ brandGuestId }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const response = await fetchReferralCodeApi({ brandGuestId })
        .then(async (response) => {
          dispatch({
            type: FETCH_REFERRAL_CODE,
            referralCode: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const generateReferralCodeAction =
  ({ generateReferralCodeReqBody }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const response = await generateReferralCodeApi({ generateReferralCodeReqBody })
        .then((response) => {
          dispatch({
            type: FETCH_REFERRAL_CODE,
            referralCode: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const fetchReferralDealsAction =
  ({ dealIds }) =>
  async (dispatch) => {
    const referrerDealIds = get(dealIds, 'referrer', []);
    const milestoneDealIds = get(dealIds, 'milestone', []);
    const gainerDealIds = get(dealIds, 'gainer', []);
    const allDealIds = Object.values(dealIds).flat();
    try {
      const referralDealDetailResponse = await fetchReferralDealsApi({ dealIds: allDealIds })
        .then((response) => {
          const referralDeals = get(response, 'data._embedded.deals', []);
          const referrerDeals = referralDeals.filter((deal) =>
            referrerDealIds.includes(get(deal, 'id')),
          );
          const gainerDeals = referralDeals.filter((deal) =>
            gainerDealIds.includes(get(deal, 'id')),
          );
          const milestoneDeals = referralDeals.filter((deal) =>
            milestoneDealIds.includes(get(deal, 'id')),
          );
          dispatch({
            type: FETCH_REFERRAL_DEALS,
            referralDeals: { referrerDeals, milestoneDeals, gainerDeals },
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return referralDealDetailResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const fetchBookingHistoryAction =
  ({ url }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());

      const bookingsResponse = await fetchBookingHistoryApi({ url })
        .then((response) => {
          const bookings = get(response, 'data', {});
          dispatch({
            type: FETCH_BOOKING_HISTORY,
            bookings,
          });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return bookingsResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchBookingDetailsByIdAction = ({ bookingId }) => async (dispatch) => {
  try {
    const response = await fetchBookingDetailsByIdApi({ bookingId });
    dispatch({
      type: FETCH_BOOKING_DETAILS,
      bookingDetails: get(response, 'data', {}),
    });
    return response;
  } catch (errorResponse) {
    return get(errorResponse, 'response', {});
  }
};

export const fetchBookingFeedbackOptionsAction = ({ bookingId, rating, locale }) => async () => {
  try {
    return await fetchBookingFeedbackOptionsApi({ bookingId, rating, locale });
  } catch (errorResponse) {
    return get(errorResponse, 'response', {});
  }
};

export const fetchBookingFeedbackStatusAction = ({ bookingId }) => async () => {
  try {
    return await fetchBookingFeedbackStatusApi({ bookingId });
  } catch (errorResponse) {
    return get(errorResponse, 'response', {});
  }
};

export const fetchExpertFeedbackSummaryAction = ({ expertId }) => async () => {
  try {
    return await fetchExpertFeedbackSummaryApi({ expertId });
  } catch (errorResponse) {
    return get(errorResponse, 'response', {});
  }
};

export const createBookingFeedbackAction =
  ({ bookingId, bookingFeedbackReqBody }) =>
  async (dispatch) => {
    try {
      return await createBookingFeedbackApi({ bookingId, bookingFeedbackReqBody });
    } catch (errorResponse) {
      dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
      return get(errorResponse, 'response', {});
    }
  };

export const fetchUserConsentsAction = () => async (dispatch) => {
  try {
    const userConsentsResponse = await fetchUserConsentsApi()
      .then((response) => {
        const userConsents = get(response, 'data', []);
        dispatch({
          type: FETCH_USER_CONSENTS,
          userConsents,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return userConsentsResponse;
  } catch (error) {
    console.log(error);
  }
};

export const updateUserConsentsAction =
  ({ userConsentsReqBody }, withLoader = true) =>
  async (dispatch) => {
    try {
      if (withLoader) {
        dispatch(beginAjaxCallAction());
      }
      const updateUserConsentsResponse = await updateUserConsentsApi({
        updateUserConsentsReqBody: userConsentsReqBody,
      })
        .then((response) => {
          dispatch({
            type: UPDATE_USER_CONSENTS,
            userConsents: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return updateUserConsentsResponse;
    } catch (error) {
      console.log(error);
    } finally {
      if (withLoader) {
        dispatch(endAjaxCallAction());
      }
    }
  };

export const fetchExpertBookingsAction =
  ({ url }) =>
  async (dispatch) => {
    try {
      const expertBookingResponse = await fetchExpertBookingsApi({ url });
      dispatch({
        type: FETCH_EXPERT_BOOKINGS,
        expertBookings: get(expertBookingResponse, 'data', []),
      });
      return expertBookingResponse;
    } catch (error) {
      console.log(error);
    }
  };

export const serviceOTPSessionAction =
  ({ otp, bookingId, isServiceInProgress }) =>
  async () => {
    try {
      const serviceOTPSessionResponse = await serviceOTPSessionApi({
        otp,
        bookingId,
        isServiceInProgress,
      });
      return serviceOTPSessionResponse;
    } catch (error) {
      return get(error, 'response', {});
    }
  };
